export const start_chat = `/chat/start_chat`;
export const chat = `/chat/chat`;
export const register = `/register`;
export const register_customer = `/register-customer`;
export const login_user = `/login`;
export const add_feedback = `/feedback`;
export const add_consultancy = `/consultationCall`;
export const change_password = `/reset-password`;
export const ingest_file = `/ingest/ingest_data`;
export const delete_file = `/ingest/delete/`;
export const ingested_files = `/ingest/ingested_files/`;
export const list_files = `/ingest/list_files`;
export const nist_frameworks = `/categories`;
export const create_framework = `/maturity_frameworks/categories`;
export const edit_framework = (category_id: number) => `/maturity_frameworks/categories/${category_id}`;
export const create_domain = `/maturity_frameworks/domains`;
export const create_question_flow = `/maturity_frameworks/question_flows`;
export const create_question = `/maturity_frameworks/questions`;
export const update_question = (question_id: number) => `/maturity_frameworks/questions/${question_id}`;

// Scoring options endpoints
export const create_scoring_option = `/maturity_frameworks/framework_options`;
export const get_framework_options = (framework_id: number) => `/maturity_frameworks/framework_options/framework/${framework_id}`;

// Update endpoints
export const update_domain = (domain_id: number) => `/maturity_frameworks/domains/${domain_id}`;
export const update_question_flow = (question_flow_id: number) => `/maturity_frameworks/question_flows/${question_flow_id}`;

// Delete endpoints
export const delete_domain = (domain_id: number) => `/maturity_frameworks/domains/${domain_id}`;
export const delete_question_flow = (question_flow_id: number) => `/maturity_frameworks/question_flows/${question_flow_id}`;
export const delete_question = (question_id: number) => `/maturity_frameworks/questions/${question_id}`;
export const delete_scoring_option = (scoring_option_id: number) => `/maturity_frameworks/framework_options/${scoring_option_id}`;
export const save_score = `/scores`;
export const ingest_file_multiple = `/ingest/multiple_use_case_ingest_data/`;
export const ingest_file_multiple_new = `/ingest/multiple_use_case_ingest_data_new/`;
export const score_history_domain = (user_id: number, domain_id: number) =>
	`/history/user/${user_id}/domain/${domain_id}`;

export const score_history_category = (user_id: number, category_id: number) =>
	`/history/user/${user_id}/category/${category_id}`;
export const user_flow_scores = (user_id: number) => `/scores/user/${user_id}`;
export const framework_domains = (framework_id: number) =>
	`/categories/${framework_id}/domains`;
export const question_flows = (domain_id: number) =>
	`/question-flows/${domain_id}`;
export const get_questions_by_flow_id = (flow_id: number) =>
	`/question_flows/${flow_id}/questions`;

export const category_score = (user_id: number) =>
	`/scores/user/${user_id}/category`;

export const get_form_data = `/update/get_data`;
export const add_vendor_data = `/update/vendordata`;
export const add_governance_data = `/update/boarddata`;

export const export_data = (user_id: number, category_id:number=0) => `/download_excel/${user_id}${category_id>0 ? `?category_id=${category_id}` : ''}`;
export const get_top_items = `/trending-topic-recommendations/topics`;
export const verify_mfa_token = `/verify-mfa-token`;